/**
 * Client Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.2.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementClientSubscriptionResponse { 
    id: string;
    type?: ManagementClientSubscriptionResponse.TypeEnum;
    emailTo?: Array<string>;
    emailCc?: Array<string>;
    emailBcc?: Array<string>;
    emailSubject?: string;
    pdfTitle?: string;
    aiSummary?: boolean;
    aiSummaryTokens?: number;
    tagLimit?: number;
    detailedClippingReport?: boolean;
    detailedClippingReportTitle?: string;
    viberEnabled?: boolean;
    viberChannelTokenMasked?: string;
    viberShowSentiment?: boolean;
    viberConnectionError?: string;
    validFrom?: Date;
    validTo?: Date;
    clientId?: string;
}
export namespace ManagementClientSubscriptionResponse {
    export type TypeEnum = 'CLIPPING' | 'ANALYTICS' | 'TRANSCRIPTIONS' | 'CONTRACT_NOTICES' | 'CONTRACT_NOTICES_KOSOVO' | 'CONTRACT_NOTICES_ALBANIA' | 'CONTRACT_NOTICES_ANNOUNCEMENTS' | 'CONTRACT_NOTICES_ANNOUNCEMENTS_KOSOVO' | 'CONTRACT_NOTICES_ANNOUNCEMENTS_ALBANIA' | 'SALES' | 'BANKRUPTCIES';
    export const TypeEnum = {
        CLIPPING: 'CLIPPING' as TypeEnum,
        ANALYTICS: 'ANALYTICS' as TypeEnum,
        TRANSCRIPTIONS: 'TRANSCRIPTIONS' as TypeEnum,
        CONTRACTNOTICES: 'CONTRACT_NOTICES' as TypeEnum,
        CONTRACTNOTICESKOSOVO: 'CONTRACT_NOTICES_KOSOVO' as TypeEnum,
        CONTRACTNOTICESALBANIA: 'CONTRACT_NOTICES_ALBANIA' as TypeEnum,
        CONTRACTNOTICESANNOUNCEMENTS: 'CONTRACT_NOTICES_ANNOUNCEMENTS' as TypeEnum,
        CONTRACTNOTICESANNOUNCEMENTSKOSOVO: 'CONTRACT_NOTICES_ANNOUNCEMENTS_KOSOVO' as TypeEnum,
        CONTRACTNOTICESANNOUNCEMENTSALBANIA: 'CONTRACT_NOTICES_ANNOUNCEMENTS_ALBANIA' as TypeEnum,
        SALES: 'SALES' as TypeEnum,
        BANKRUPTCIES: 'BANKRUPTCIES' as TypeEnum
    };
}